import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    FormGroup,
    FormControlLabel,
    Checkbox,
    Slide,
    IconButton,
    Link as MuiLink,
} from '@mui/material';
import { Link } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import CookieService from '../services/CookieService';
import '../styles/CookieBanner.scss';

const CookieBanner = () => {
    const [open, setOpen] = useState(false);
    const [showSettings, setShowSettings] = useState(false);
    const [settings, setSettings] = useState(CookieService.getDefaultSettings());

    useEffect(() => {
        const consentStatus = CookieService.getConsentStatus();
        if (!consentStatus) {
            setOpen(true);
        }
    }, []);

    const handleAcceptAll = () => {
        CookieService.acceptAllCookies();
        setOpen(false);
    };

    const handleRejectAll = () => {
        CookieService.rejectAllCookies();
        setOpen(false);
    };

    const handleSaveSettings = () => {
        CookieService.setCookieSettings(settings);
        setOpen(false);
    };

    const handleSettingChange = (setting) => {
        setSettings(prev => ({
            ...prev,
            [setting]: !prev[setting]
        }));
    };

    const cookieTypes = [
        {
            id: 'necessary',
            title: 'Szükséges cookie-k',
            description: 'Ezek a cookie-k szükségesek a weboldal működéséhez és nem kapcsolhatók ki.',
            required: true
        },
        {
            id: 'functional',
            title: 'Funkcionális cookie-k',
            description: 'Ezek a cookie-k lehetővé teszik a weboldal funkcióinak testreszabását.',
            required: false
        },
        {
            id: 'analytics',
            title: 'Analitikai cookie-k',
            description: 'Ezek a cookie-k segítenek nekünk megérteni, hogyan használják a látogatók a weboldalt.',
            required: false
        },
        {
            id: 'marketing',
            title: 'Marketing cookie-k',
            description: 'Ezek a cookie-k segítenek nekünk a célzott hirdetések megjelenítésében.',
            required: false
        }
    ];

    return (
        <Dialog
            open={open}
            maxWidth="sm"
            fullWidth
            className="cookie-banner"
            TransitionComponent={Slide}
            TransitionProps={{ direction: 'up' }}
        >
            <DialogTitle>
                Cookie beállítások
                <IconButton
                    aria-label="close"
                    onClick={() => setShowSettings(false)}
                    sx={{ position: 'absolute', right: 8, top: 8 }}
                    className="close-button"
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                {!showSettings ? (
                    <>
                        <Typography variant="body1" gutterBottom>
                            Weboldalunk cookie-kat használ a felhasználói élmény javítása érdekében. 
                            A cookie-k segítenek nekünk megérteni, hogyan használják a látogatók az oldalt, 
                            és lehetővé teszik számunkra a weboldal fejlesztését.
                        </Typography>
                        <Box mt={2}>
                            <MuiLink
                                component={Link}
                                to="/adatkezeles"
                                color="primary"
                                underline="hover"
                            >
                                További információk az adatkezelésről
                            </MuiLink>
                        </Box>
                    </>
                ) : (
                    <FormGroup>
                        {cookieTypes.map((type) => (
                            <Box key={type.id} className="cookie-setting-item">
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={settings[type.id]}
                                            onChange={() => !type.required && handleSettingChange(type.id)}
                                            disabled={type.required}
                                        />
                                    }
                                    label={type.title}
                                />
                                <Typography variant="body2" color="textSecondary">
                                    {type.description}
                                </Typography>
                            </Box>
                        ))}
                    </FormGroup>
                )}
            </DialogContent>
            <DialogActions className="cookie-actions">
                {!showSettings ? (
                    <>
                        <Button onClick={handleRejectAll} color="inherit">
                            Elutasítom mind
                        </Button>
                        <Button onClick={() => setShowSettings(true)} color="primary">
                            Beállítások
                        </Button>
                        <Button onClick={handleAcceptAll} variant="contained" color="primary">
                            Elfogadom mind
                        </Button>
                    </>
                ) : (
                    <>
                        <Button onClick={() => setShowSettings(false)} color="inherit">
                            Vissza
                        </Button>
                        <Button onClick={handleSaveSettings} variant="contained" color="primary">
                            Beállítások mentése
                        </Button>
                    </>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default CookieBanner; 